import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/custcash',
    //客户全称
    query(query) {
        return http({
            url: this.baseurl + '/bscCustcashSum/selectPage',
            method: 'post',
            params:query
        });
    },
    detail(query) {
        return http({
            url: this.baseurl + '/bscCustcashDetail/selectPage',
            method: 'post',
            params:query
        });
    },
    //
    selectBySid(v){
        return http.post('/api/swyl/v1/custcash/bscCustcashSum/selectBySid?sid='+v);
    }
}